module.exports = __webpack_public_path__ + "img/pic03.9211b94f.png";